import type { ComponentProps } from 'react';

import { Label, Checkbox as OriginalCheckbox } from '@mint-lib/tw-components';

type CheckboxProps = ComponentProps<typeof OriginalCheckbox> & {
  label?: string;
};

export const CheckboxWithLabel = ({ label, ...rest }: CheckboxProps) => (
  <Label variant="bodyLong01" className="items-start gap-1.5">
    <OriginalCheckbox {...rest} />
    <span className="-mt-[3px]">{label}</span>
  </Label>
);
